

































import { Component, Vue } from "vue-property-decorator";
import { AuthModule, SurveyModule } from "@/store";
import { StatusUserStrategy, SurveyType, SurveyStatusResult } from "@/interfaces";
import { getStatusUserStrategy } from "@/services";
import { date } from "quasar";

@Component
export default class StrategySummary extends Vue {
  @SurveyModule.bindings.Mutation
  setSurveyType!: (type: SurveyType | null) => void;

  @AuthModule.bindings.State
  status!: SurveyStatusResult;

  loading = false;

  statusUserStrategy: StatusUserStrategy | null = null;

  async mounted() {
    this.setSurveyType(SurveyType.USER_STRATEGY);
    this.loading = true;

    try {
      this.statusUserStrategy = await getStatusUserStrategy();
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  get parsedDate() {
    if (this.status.has_user_strategy !== null) {
      return date.formatDate(this.statusUserStrategy?.updated_at, "DD/MM/YYYY HH:MM");
    }

    return "";
  }

  destroyed() {
    this.setSurveyType(null);
  }
}
